/* eslint-disable @angular-eslint/component-selector */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientPrescriberTask } from '../../../core/models/client-prescriber-task.model';
import { RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { PrescriptionNameComponent } from '../../../shared/components/prescription-name/prescription-name.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { ExpirationDateComponent } from '../../../shared/components/expiration-date/expiration-date.component';
import { ClaimSourcePipe } from '../../../shared/pipes/claim-source.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: '[app-client-prescriber-task-list-row]',
    templateUrl: './client-prescriber-task-list-row.component.html',
    styleUrls: ['./client-prescriber-task-list-row.component.scss'],
    imports: [RouterLink,
              UserPresenceComponent,
              PrescriberNameComponent,
              PrescriptionNameComponent,
              TaskEstimatedValueComponent,
              ExpirationDateComponent,
              ClaimSourcePipe,
              BlankValueDashPipe]
})
export class ClientPrescriberTaskListRowComponent {
  @Input() task: ClientPrescriberTask;
  @Input() position: number;

  @Output() viewTask = new EventEmitter<number>();

  constructor() {}


  onViewClick() {
    this.viewTask.emit(this.position);
  }
}
